import { createApplier } from '@/app/libs/I';

/**
 * @deprecated legacy
 */
export namespace landerRequestService {
  /**
   * @deprecated legacy
   */
  export const applierId = Symbol('lander-service');
  /**
   * @deprecated legacy
   */
  export const apply = createApplier(applierId);

  /**
   * @deprecated legacy
   */
  export function normalizeString(val: string) {
    return val.replace(/[^ёЁА-Яа-яA-Za-z\s]/g, '');
  }
}
